// import faker from 'faker';
import _ from 'lodash';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import ProductInventory from '@/entities/ProductInventory';
// import services from 'services';
import { db, firebase } from '@/vendors/firebase/firebase';

const axios = require('axios');
const ls = require('local-storage');

let domainApi = 'apiweb-staging';
if (process.env.VUE_APP_FIREBASE_PROJECT_ID === 'inventaire-mb-as-prod') {
  domainApi = 'apiweb';
}

export default {
  async getProductsByStore() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);

    const transformedReponseData = [];
    // let quantity;
    // const hourMorning = 16;
    // const hourEvening = 18;

    const today = new Date();
    // const today = new Date('2020-08-01');

    const inventaireId = await db.collection('shops').doc(storeId).collection('inventaires')
      // .where('dateBeg', '<=', today)
      .where('dateEnd', '>=', today)
      .where('status', '==', 'A')
      .get()
      .then((querySnapshot) => {
        let value = 0;
        if (!querySnapshot.empty) {
          const inventaireHead = querySnapshot.docs[0].data();
          // On check si bien dateBeg <= now <= dateEnd
          // On peut pas filtrer sur dateBeg
          const dateBeg = moment(inventaireHead.dateBeg.toDate());
          if (moment().isAfter(dateBeg)) {
            value = inventaireHead.inventoryId;
          }
          console.log('DATE DE INVENTAIRE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
          console.log(dateBeg);
        }
        return value;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    const date = moment();
    await db.collection('shops').doc(storeId).collection('inventaireProducts')
      .where('inventoryId', '==', inventaireId)
      .orderBy('family')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(async (doc) => {
          // doc.data() is never undefined for query doc snapshots
          // const product = { ...doc.data(), date: moment(new Date()).format('DD/MM/YYYY') };
          const product = { ...doc.data(), date: date.format('DD/MM/YYYY') };
          transformedReponseData.push(new ProductInventory(product));
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });
    console.log('transformedReponseData', transformedReponseData);
    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async getInventaireHeadByStore() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);

    const today = new Date();
    // const today = new Date('2020-06-30');

    const inventaireHead = await db.collection('shops').doc(storeId).collection('inventaires')
      // .where('dateBeg', '<=', today) <-- Pas besoin dateBeg car import a dateBeg
      .where('dateEnd', '>=', today)
      .where('status', '==', 'A')
      .get()
      .then((querySnapshot) => {
        let value = { inventoryId: 0, storeId: 0, dateEnd: null };
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs[0].data();
          value = data;
        }
        return value;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });
    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(inventaireHead));
    // return true;
  },
  async checkIfCurrentInventaireValidated() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);
    const today = new Date();
    // const today = new Date('2020-08-01');

    const res = await db.collection('shops').doc(storeId).collection('inventaires')
      // .where('dateBeg', '<=', today)
      .where('dateEnd', '>=', today)
      .where('status', '==', 'Z')
      .get()
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const inventaireHead = querySnapshot.docs[0].data();
          // On check si bien dateBeg <= now <= dateEnd
          // On peut pas filtrer sur dateBeg
          const dateBeg = moment(inventaireHead.dateBeg.toDate());
          if (moment().isAfter(dateBeg)) {
            return dateBeg.format('DD/MM/YYYY');
          }
          return false;
          // console.log('DATE DE INVENTAIRE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
          // console.log(dateBeg);
        }
        return false;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
        return false;
      });
    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(res));
    // return true;
  },
  async getProductsAverageQtyByStore() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);

    const transformedReponseData = {};
    // let quantity;

    // date debut foodMeUp mercurial (pour avoir les nouveaux id produit)
    // surement 15/01/2020
    const dateFoodMeUp = new Date('2020-01-07');

    const inventaireIds = await db.collection('shops').doc(storeId).collection('inventaires')
      // .where('dateBeg', '<=', today) <-- Pas besoin dateBeg car import a dateBeg
      .where('dateEnd', '>=', dateFoodMeUp)
      .where('status', '==', 'Z')
      .where('inventoryType', '==', 'INV_CLASSIQUE')
      .orderBy('dateEnd', 'desc')
      .limit(3)
      .get()
      .then((querySnapshot) => {
        const arrayResult = [];
        querySnapshot.forEach(async (doc) => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, ' => ', doc.data());
          arrayResult.push(doc.data().inventoryId);
        });

        return arrayResult;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    if (inventaireIds.length > 0) {
      const resData = await db.collection('shops').doc(storeId).collection('inventaireProducts')
        .where('inventoryId', 'in', inventaireIds)
        .orderBy('family')
        .get()
        .then((querySnapshot) => {
          // const arrayResult = [];
          const arrayResult = {};
          querySnapshot.forEach(async (doc) => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, ' => ', doc.data());

            const productData = { ...doc.data() };
            const product = new ProductInventory(productData);
            const quantityTotal = product.quantityAreaSelling + product.quantityAreaStock;
            if (quantityTotal !== 0) {
              arrayResult[product.productId] = _.get(arrayResult, product.productId, []);
              arrayResult[product.productId].push(quantityTotal);
            }
            // transformedReponseData.push(new ProductInventory(product));
          });
          return arrayResult;
        })
        .catch((error) => {
          console.log('Error getting documents: ', error);
        });

      _.forEach(resData, (productMean, productId) => {
        const mean = _.mean(productMean);
        // console.log(productId, ' => ', mean);
        transformedReponseData[productId] = _.get(transformedReponseData, productId, null);
        transformedReponseData[productId] = Math.round(mean);
      });
    }
    // console.log('transformedReponseData', transformedReponseData);

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async setQuantityInventory(data, userId) {
    // const momentObj = moment(data.date, 'DD/MM/YYYY');
    // const dateString = momentObj.format('YYYY-MM-DD');
    const inventoryRef = db.collection('shops').doc(data.storeId)
      .collection('inventaireProducts')
      .doc(`${data.inventoryId}-${data.productId}`);

    // const isCompleted = data.stockJ !== null && data.stockJ !== undefined;
    const product = {
      ...data,
      lastUserUpdated: userId,
      // isCompleted,
      // date: firebase.firestore.Timestamp.fromDate(new Date(dateString)),
    };

    const result = await inventoryRef.set(product, { merge: true });
    // const result = await inventoryRef.update(product);

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(result));
    // return true;
  },
  async getInventairesHead() {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    const transformedReponseData = [];
    console.log('listing des product ID');
    await db.collection('shops').doc(storeId).collection('inventaires')
      .orderBy('dateBeg', 'desc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' ==> ', doc.data());
          const dateBeg = doc.data().dateBeg.toDate();
          const dateEnd = doc.data().dateEnd.toDate();
          const headInventaire = { ...doc.data(), dateBeg: moment(dateBeg).format('DD/MM/YYYY'), dateEnd: moment(dateEnd).format('DD/MM/YYYY') };
          transformedReponseData.push(headInventaire);
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async getInventaireByIdAndStore(inventaireId) {
    const shopToken = ls.get('shopToken');
    const { shopId: storeId } = jwtDecode(shopToken);
    console.log('storeId');
    console.log(storeId);

    const transformedReponseData = [];
    // let quantity;
    // const hourMorning = 16;
    // const hourEvening = 18;

    await db.collection('shops').doc(storeId).collection('inventaireProducts')
      .where('inventoryId', '==', inventaireId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(async (doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, ' => ', doc.data());

          // const product = { ...doc.data(), date: moment(new Date()).format('DD/MM/YYYY') };
          const product = { ...doc.data() };
          transformedReponseData.push(new ProductInventory(product));
        });
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });
    console.log('transformedReponseData', transformedReponseData);
    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(transformedReponseData));
    // return true;
  },
  async validInventaire(inventoryId, storeId, userId) {
    const inventoryRef = db.collection('shops').doc(storeId)
      .collection('inventaires')
      .doc(inventoryId);
    const data = {
      status: 'Z',
      // dateValidation: '2002020',
      dateValidation: firebase.firestore.Timestamp.fromDate(new Date()),
      userValidator: userId,
    };
    const result = await inventoryRef.set(data, { merge: true });
    // const result = await inventoryRef.update(product);
    // save screen infos quand shop valide son inventaire
    const infosValid = {
      userValidator: userId,
      userAgent: navigator.userAgent,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
    };
    // Add doc to check who has products inventory
    db.collection('listShopsHasInventaireProducts')
      .doc(`${storeId}-${inventoryId}`).set({
        shopId: storeId,
        inventaireId: inventoryId,
        infosValid,
      }, { merge: true });

    // Add doc to execute cloud function : exportInventaire
    db.collection('listShopsExportInventaire').add({
      storeId,
    });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(result));
    // return true;
  },
  async displayDateSaisie(inventoryId, storeId) {
    const dateFormat = await db.collection('shops').doc(storeId).collection('inventaires')
      // .where('dateBeg', '<=', today) <-- Pas besoin dateBeg car import a dateBeg
      .where('inventoryId', '==', inventoryId)
      .get()
      .then((querySnapshot) => {
        let value = '';
        if (!querySnapshot.empty) {
          const inventaireHead = querySnapshot.docs[0].data();
          let dateEnd = inventaireHead.dateEnd.toDate();
          dateEnd = moment(dateEnd);
          dateEnd = dateEnd.format('DD/MM/YYYY');
          value = `Date limite : ${dateEnd}`;
        }
        return value;
      })
      .catch((error) => {
        console.log('Error getting documents: ', error);
      });

    return dateFormat;
  },
  createDocToImportHistory(inventoryId, shopId) {
    const data = {
      shopId,
      inventoryId,
    };

    // Add doc to execute cloud function : exportInventaire
    const result = db.collection('listShopsImportInventaireHistory').add(data);

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => resolve(result));
    // return true;
  },
  async importHistory(inventoryId, storeId) {
    const listProducts = await axios({
      method: 'get',
      url: `https://${domainApi}.groupe-blachere.com/inventaire/getInventaireProductsHistory.php?shopId=${storeId}&inventoryId=${inventoryId}`,
    })
      .then((reponse) => reponse.data)
      .catch((erreur) => {
        // On traite ici les erreurs éventuellement survenues
        console.log('erreur axios');
        console.log(erreur);
        return erreur;
      });

    console.log('listProducts');
    console.log(listProducts);

    // const listProducts = res;
    let res2;
    if (listProducts) {
      // Get a new write batch
      const batch = db.batch();

      listProducts.forEach((product) => {
        const docRef = db.collection('shops').doc(product.storeId).collection('inventaireProducts').doc(`${product.inventoryId}-${product.productId}`);
        const dateBeg = new Date(product.dateBeg);
        const dateEnd = new Date(product.dateEnd);
        const data = {
          ...product,
          dateBeg: firebase.firestore.Timestamp.fromDate(dateBeg),
          dateEnd: firebase.firestore.Timestamp.fromDate(dateEnd),
        };
        batch.set(docRef, data, { merge: true });
      });

      res2 = await batch.commit();
    } else {
      res2 = null;
    }
    // return new Promise((resolve) => resolve(transformedReponseData));
    return new Promise((resolve) => resolve(res2));
  },
  async createInventaireProductsFromFront(shopId, inventaireId, userId) {
    const baseUrlCloudFunction = process.env.VUE_APP_FIREBASE_CLOUDFUNCTIONS_BASE_URL;
    const res = await axios({
      method: 'get',
      // url: `http://localhost:5001/app-inventaire-hbb-dev-absam/us-central1/createInventaireProductsFromFront?shopId=${shopId}&inventaireId=${inventaireId}`,
      // url: `https://us-central1-app-inventaire-hbb-dev-absam.cloudfunctions.net/createInventaireProductsFromFront?shopId=${shopId}&inventaireId=${inventaireId}`,
      url: `${baseUrlCloudFunction}/createInventaireProductsFromFront?shopId=${shopId}&inventaireId=${inventaireId}`,
      headers: { 'Access-Control-Allow-Origin': '*' },
    })
      .then((reponse) => reponse.data)
      .catch((erreur) => {
        // On traite ici les erreurs éventuellement survenues
        console.log('erreur axios');
        console.log(erreur);
        return false;
      });
    // console.log('res $$$$');
    // console.log(res);

    if (res === true) {
      const infosGener = {
        userGenerator: userId,
        userAgent: navigator.userAgent,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
      };
      // Add doc to check who has products inventory
      db.collection('listShopsHasInventaireProducts')
        .doc(`${shopId}-${inventaireId}`).set({
          shopId,
          inventaireId,
          infosGener,
        }, { merge: true });
    }

    // console.log(inventaireId);
    // const res = await axios({
    //   method: 'get',
    //   url: `https://apiweb-staging.groupe-blachere.com/inventaire/fakeMercurialsFoodMeUp.php?id_store=${shopId}`,
    //   headers: { 'Access-Control-Allow-Origin': '*' },
    // })
    //   .then((reponse) => {
    //     // On traite la suite une fois la réponse obtenue
    //     console.log('');
    //     return reponse.data;
    //     // return res;
    //   })
    //   .catch((erreur) => {
    //     // n traite ici les erreurs éventuellement survenues
    //     console.log(erreur);
    //     return false;
    //   });
    return res;
  },
  async getFrontEndMessages() {
    const listFrontEndMessages = await axios({
      method: 'get',
      url: `https://${domainApi}.groupe-blachere.com/inventaire/getFrontEndMessages.php`,
    })
      .then((reponse) => reponse.data)
      .catch((erreur) => {
        // On traite ici les erreurs éventuellement survenues
        console.log('erreur axios');
        console.log(erreur);
        return [];
      });

    console.log('listFrontEndMessages');
    console.log(listFrontEndMessages);

    // const listProducts = res;
    // let res2 = null;

    // return new Promise((resolve) => resolve(transformedReponseData));
    return new Promise((resolve) => resolve(listFrontEndMessages));
  },
};
